import { ColumnConfig, ColumnDataType, getFieldValuesFromEnum } from '@aurora';
import { DigitaiFleetTabType } from '../digitai.types';

export const fleetTabColumnsConfig: ColumnConfig[] = [
    {
        type       : ColumnDataType.STRING,
        field      : 'name',
        sort       : 'name',
        translation: 'Name',
        isUnaccent : true,
    },
    {
        type       : ColumnDataType.ENUM,
        field      : 'type',
        sort       : 'type',
        translation: 'Type',
        fieldValues: () => getFieldValuesFromEnum(DigitaiFleetTabType),
    },
    {
        type       : ColumnDataType.NUMBER,
        field      : 'sort',
        sort       : 'sort',
        translation: 'digitai.Sort',
    },
    {
        type       : ColumnDataType.BOOLEAN,
        field      : 'isMaster',
        sort       : 'isMaster',
        translation: 'IsMaster',
    },
    {
        type       : ColumnDataType.BOOLEAN,
        field      : 'isActive',
        sort       : 'isActive',
        translation: 'IsActive',
    },
];
